import { HttpClient } from "../httpClient";
import CostPerChildFilterOptions from "../models/costPerChildFilterOptions";
import CostPerChildCustomRequest from "../responses/costPerChildCustomRequest";
import { DataResponse } from "../responses/baseResponse";

const httpClient = new HttpClient();

export const downloadCostPerChild = async (districtId:number, month:number, year:number, programId: number | null) => {
    programId = programId === null ? -1 : programId;
    return httpClient.downloadAwaitable({
      url: `/v1/CostPerChild/${districtId}?month=${month}&year=${year}&programId=${programId}`,
      requiresToken: true,
    });
  };

export const downloadCostPerChildCustom = async (request:CostPerChildCustomRequest) => {
  let query = "?";
   
  if(request.districtId !== null) query += `districtId=${request.districtId}&`;
  query += `&startDate=${request.startDate.toISOString()}`;
  query += `&endDate=${request.endDate.toISOString()}`;
  if(request.userId !== null) query += `&userId=${request.userId}`;
  if(request.divisionId !== null) query += `&divisionId=${request.divisionId}`;
  if(request.disciplineId !== null)  query += `&disciplineId=${request.disciplineId}`;
  if(request.disciplineGroupId !== null) query += `&disciplineGroupId=${request.disciplineGroupId}`;
  if(request.ckyFlag !== null) query += `&ckyFlag=${request.ckyFlag}`;
  query += `&payRatesMissing=${request.payRatesMissing}`;
  query += `&billRateMissing=${request.billRateMissing}`;
  if(request.paidMonthlyFlag !== null) query += `&paidMonthlyFlag=${request.paidMonthlyFlag}`;

  return httpClient.downloadAwaitable({
    url: `/v1/CostPerChild/Custom${query}`,
    requiresToken: true,
  });
};

export const getCostPerChildOptions = async () => {
  return httpClient.get<DataResponse<CostPerChildFilterOptions>>({
    url: '/v1/CostPerChild/FilterOptions',
    requiresToken: true
  });
  
}